var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconUserinfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 21V19C20 17.9391 19.5505 16.9217 18.7503 16.1716C17.9502 15.4214 16.8649 15 15.7333 15H8.26667C7.13508 15 6.04983 15.4214 5.24968 16.1716C4.44952 16.9217 4 17.9391 4 19V21M16.2667 7C16.2667 9.20914 14.3564 11 12 11C9.64358 11 7.73333 9.20914 7.73333 7C7.73333 4.79086 9.64358 3 12 3C14.3564 3 16.2667 4.79086 16.2667 7Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconUserinfo);
export default __webpack_public_path__ + "static/media/button-icon-userinfo.249e88936746755db54e16a8f7fe7b0d.svg";
export { ForwardRef as ReactComponent };